import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/img/r-code.jpg';
import _imports_1 from '@/assets/img/dianhua.png';
import _imports_2 from '@/assets/img/r-gzh.jpg';
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  key: 0,
  class: "kf"
};
const _hoisted_3 = {
  key: 1,
  class: "us"
};
const _hoisted_4 = {
  class: "s_but"
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.form.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_avatar, {
    size: 50,
    src: require('@/assets/img/zxkf.png')
  }, null, 8, ["src"]), _cache[1] || (_cache[1] = _createStaticVNode("<p class=\"text\" data-v-33750372>咨询客服</p><div class=\"code\" data-v-33750372><p class=\"til\" data-v-33750372>专注于品牌多门店数智化经营系统</p><div data-v-33750372><img style=\"width:160px;padding:15px 0 5px;\" src=\"" + _imports_0 + "\" alt=\"\" data-v-33750372><h4 data-v-33750372>商务合作咨询</h4><h1 style=\"margin-top:10px;display:flex;justify-content:center;align-items:center;\" data-v-33750372><img style=\"width:24px;\" src=\"" + _imports_1 + "\" alt=\"\" data-v-33750372><span class=\"spa\" style=\"padding-left:5px;font-size:18px;\" data-v-33750372>153-0719-3890</span></h1></div></div>", 2))])) : _createCommentVNode("", true), _ctx.form.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [_createElementVNode("p", {
    class: "text"
  }, "关注我们", -1), _createElementVNode("div", {
    class: "gzh"
  }, [_createElementVNode("img", {
    style: {
      "width": "160px",
      "padding": "15px 0 0px"
    },
    src: _imports_2,
    alt: ""
  }), _createElementVNode("h3", null, "关注官方微信公众号")], -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.changeShow && _ctx.changeShow(...args))
  }, [_createElementVNode("img", {
    src: _ctx.form.type == 1 ? require('@/assets/icon/to_r.png') : require('@/assets/icon/to_l.png'),
    width: "12",
    alt: ""
  }, null, 8, _hoisted_5)])])], 512)), [[_vShow, _ctx.form.switch == 1]]);
}